import React from 'react';

function Sidebar({ currentView, setCurrentView }) {
    const navItems = [
        { id: 'dashboard', label: 'Dashboard' },
        { id: 'upload', label: 'Upload Products' },
        { id: 'reviews', label: 'Reviews' },
        { id: 'products', label: 'Products' },
        { id: 'vendors', label: 'Vendors' },
    ];

    return (
        <div className="w-64 bg-gray-800 text-white flex flex-col p-4 shadow-lg">
            <h2 className="text-2xl font-bold mb-6 text-center text-blue-300">Admin User</h2>
            <nav>
                <ul className="space-y-2">
                    {navItems.map(item => (
                        <li key={item.id}>
                            <button
                                onClick={() => setCurrentView(item.id)}
                                className={`w-full text-left py-2 px-4 rounded-md transition-colors duration-200 ${currentView === item.id ? 'bg-gray-700 text-blue-300' : 'hover:bg-gray-700'}`}
                            >
                                {item.label}
                            </button>
                        </li>
                    ))}
                </ul>
            </nav>
        </div>
    );
}

export default Sidebar;
